import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    requestGetSolicitorGroups,
    getGroupQuestionsSpec, getGroupSpecDto
} from "../../actions/solicitorGroup";
import {
    requestGetQuestions
} from "../../actions/applicationFormreferralSettings";
import {requestLawsysFirms} from "../../actions/lawsysFirms";
import {requestGetSpecificSolicitorGroup} from "../../actions/groups";
import _ from 'lodash';
import { push,goBack } from 'connected-react-router';
import {getCaseTypes} from "../../actions/caseTypes";
import SolicitorGroupSpec
    from "../../components/solicitorGroup/solicitorGroupSpec";
import {requestGetSolicitorGroupOfApplication} from "../../actions/applicationPolicy";
import {requestBreachCausationCp} from "../../actions/breachCausationCp";

class SolicitorGroupSpecHOC extends Component {
    componentWillMount() {
        let route = this.props.router.location.pathname;
        let splitedRoute = _.split(route,'/',5);
        if (route.includes('/solicitors/solicitor-groups/edit-solicitor-group')) {
            this.props.requestGetSolicitorGroupOfApplication(splitedRoute[4])
            this.props.getQuestionsSpec({groupId: splitedRoute[4]})
        }
        this.props.requestBreachCausationCp();
        this.props.getQuestions();
        this.props.getGroupSpecDto();
    };
    //function that calculated the sub cases to be features on the multi select based on the selected case types
    getSubCasesBasedOnSelectedCases = () => {
        let checkedCaseTypesIds = [...this.props.solicitorGroup.checkedCaseTypesIds];
        let subCaseTypes = this.props.caseTypes.subCases;
        let featuredSubCases = [];
        _.forEach(checkedCaseTypesIds, (caseTypeId) => {
            featuredSubCases = [...featuredSubCases, ..._.filter(subCaseTypes, item => {return item.caseTypeId === caseTypeId} )]
        });
        return featuredSubCases;
    };
    render() {
        return (
          <SolicitorGroupSpec {...this.props} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        solicitorGroup: state.applicationPolicy.solicitorGroup,
        lawsysFirms: state.lawsysFirms,
        router: state.router,
        solicitorGroupsList: state.solicitorGroupsList,
        caseTypes: state.caseTypes,
        questions: state.applicationFormReferralSettings.questions,
        questionsSpec: state.groupQuestionsSpec,
        breachCausationCp: state.breachCausationCp
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSolicitors: () => {
            dispatch(requestLawsysFirms())
        },
        getSolicitorGroups: () => {
            dispatch(requestGetSolicitorGroups())
        },
        requestLawsysFirms: () => {
            dispatch(requestLawsysFirms())
        },
        requestGetSpecificSolicitorGroup: (id) => {
            dispatch(requestGetSpecificSolicitorGroup(id))
        },
        requestGetSolicitorGroupOfApplication: (id)=> {
            dispatch(requestGetSolicitorGroupOfApplication(id))
        },
        getCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        getQuestions: () => {
            dispatch(requestGetQuestions())
        },
        getQuestionsSpec: (payload) => {
            dispatch(getGroupQuestionsSpec(payload))
        },
        getGroupSpecDto: (payload) => {
            dispatch(getGroupSpecDto(payload))
        },
        requestBreachCausationCp: (payload) => {
            dispatch(requestBreachCausationCp(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorGroupSpecHOC);
